import { DeployAttributes } from './types';
import { axiosClient } from '../axiosClient';

export const getDeployAttributesById = async (deploy_id: number) => {
  return axiosClient.get<DeployAttributes>(
    `/deployments/${deploy_id}/attributes`
  );
};
